import React from 'react'
import {Uppercase} from '@dekk/text'

export default () => (
    <header>whaat?</header>
)
